import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
// import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import CheckWebP from "../Common/CheckWebP";
import BackImage from "../Media/back15.jpg";
import DecorImage from "../Media/decor.png";
import DecorUpImage from "../Media/decorUp.png";
import BackImageWebP from "../Media/back15.webp";
import DecorImageWebP from "../Media/decor.webp";
import DecorUpImageWebP from "../Media/decorUp.webp";

import RunnerProfileDialog from "../Dialogs/RunnerProfileDialog.jsx";

const styles = theme => ({
	card: {
		maxWidth: "100%"
	},
	media: {
		height: "auto"
	},
	listButton: {
		padding: 2,
		textTransform: "none",
		fontWeight: 400,
		letterSpacing: "0.00938em",
		lineHeight: 1.5,
		fontSize: "1rem",
		textAlign: "left"
	},
	decorUp: {
		marginBottom: "-5px"
	},
	textBox: {
		backgroundColor: theme.palette.white,
		margin: 20,
		padding: 20,
		borderRadius: 20,
		display: "inline-block",
		flexBasis: "auto",
		[theme.breakpoints.up("lg")]: {
			flexBasis: "100%"
		}
	},
	cardHeader: {
		backgroundColor: theme.palette.white70
	},
	hrline: {
		[theme.breakpoints.down("md")]: {
			display: "none"
		}
	},
	vrline: {}
});

class WinnersCard extends React.Component {
	constructor() {
		super();
		this.state = {
			open: false,
			men: [],
			women: [],
			category: [],
			date: "",
			fetCategory: { val: 0, label: "" }
		};
	}

	componentDidMount = () => {
		const { results, lastEvent, lastEventStats } = this.props;

		var men = [];
		var women = [];
		var category = [];
		var possibleFeat = [];
		var fetCategory = { val: 0, label: "" };

		lastEventStats.categoryData.series.forEach((val, index) => {
			if (val > 2) {
				possibleFeat.push({
					label: lastEventStats.categoryData.labels[index]
						.split(" ")[0]
						.replace("M", "Male ")
						.replace("F", "Female "),
					val: val
				});
			}
		});

		fetCategory = possibleFeat[Math.floor(Math.random() * possibleFeat.length)];

		results.forEach(row => {
			if (row[4].indexOf("Female") === -1) {
				men.push(row);
			} else {
				women.push(row);
			}

			if (fetCategory && row[4] === fetCategory.label) {
				category.push(row);
			}
		});

		const date = " - " + lastEvent;

		const bestMen = (
			<ol>
				{men.length > 0 && this.listWrapper(men[0])}
				{men.length > 1 && this.listWrapper(men[1])}
				{men.length > 2 && this.listWrapper(men[2])}
			</ol>
		);

		const bestWomen = (
			<ol>
				{women.length > 0 && this.listWrapper(women[0])}
				{women.length > 1 && this.listWrapper(women[1])}
				{women.length > 2 && this.listWrapper(women[2])}
			</ol>
		);

		const bestCategory = (
			<ol>
				{category.length > 0 && this.listWrapper(category[0])}
				{category.length > 1 && this.listWrapper(category[1])}
				{category.length > 2 && this.listWrapper(category[2])}
			</ol>
		);
		this.setState({ bestMen, bestWomen, bestCategory, date, fetCategory });
	};

	listWrapper = runner => {
		const { classes } = this.props;
		return (
			<li>
				<Button
					onClick={() => {
						this.setState({ open: true, runner });
					}}
					className={classes.listButton}
				>
					{`${runner[3]} | ${runner[5]} `}
				</Button>
			</li>
		);
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	render = () => {
		const { classes } = this.props;
		const { bestMen, bestWomen, bestCategory, date, fetCategory } = this.state;

		return (
			<React.Fragment>
				<RunnerProfileDialog
					open={this.state.open}
					close={this.handleClose}
					runner={this.state.runner}
				/>
				<Card className={classes.card}>
					<CardMedia
						className={classes.media}
						image={CheckWebP() ? BackImageWebP : BackImage}
					>
						<img
							src={CheckWebP() ? DecorImageWebP : DecorImage}
							alt={"decorImage"}
						/>
						<CardHeader
							title={<i>Top 3 {date}</i>}
							className={classes.cardHeader}
						/>

						<CardContent className={classes.content}>
							<Grid container>
								<Grid item xs={12} md={5} className={classes.textBox}>
									<Typography variant="caption">overall</Typography>
									<Typography component="h6">Women</Typography>
									<Typography variant="body1" component="span">
										{bestWomen ? bestWomen : "No results yet"}
									</Typography>
								</Grid>
								<hr className={classes.hrline} />
								<Grid item xs={12} md={5} className={classes.textBox}>
									<Typography variant="caption">overall</Typography>
									<Typography component="h6">Men</Typography>
									<Typography variant="body1" component="span">
										{bestMen ? bestMen : "No results yet"}
									</Typography>
								</Grid>
							</Grid>
							<hr className={classes.vrline} />
							{fetCategory && (
								<Grid item xs={12} className={classes.textBox}>
									<Typography variant="h5" component="h2">
										{`Featured category`}
									</Typography>

									<Typography component="h5">{fetCategory.label}</Typography>
									<Typography variant="body1" component="span">
										{bestCategory ? bestCategory : "No results yet"}
									</Typography>
								</Grid>
							)}
						</CardContent>
						<img
							src={CheckWebP() ? DecorUpImageWebP : DecorUpImage}
							className={classes.decorUp}
							alt={"decorImage"}
						/>
					</CardMedia>
				</Card>
			</React.Fragment>
		);
	};
}

WinnersCard.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(WinnersCard);
